import { t } from 'i18next'

import DateInterval from '~/components/DateInterval'

import * as S from './styles'

const DurationDate = ({
  data,
  isEditMode,
  inputNames,
  hasBorderAtFirst = true
}: DurationDateProps) => {
  const FirstSectionComponent = hasBorderAtFirst ? S.SectionWrapper : 'div'

  return (
    <>
      {isEditMode ? (
        <FirstSectionComponent>
          <DateInterval
            inputNames={inputNames}
            variant="primary"
            disabledStartDate
            showTooltip
            initialData={{ end_at: data.raw.end_at || null }}
          />
        </FirstSectionComponent>
      ) : (
        <S.Container>
          <FirstSectionComponent>
            <S.Title>Data de início</S.Title>
            <S.Text className="dateLabel">{data.startDateWithHours}</S.Text>
          </FirstSectionComponent>

          <S.SectionWrapper>
            <S.Title>Data de término</S.Title>
            <S.Text className="dateLabel">
              {data.endDateWithHours || t('rm:noEndDateDefined')}
            </S.Text>
          </S.SectionWrapper>

          {!!data.duration && (
            <S.SectionWrapper>
              <S.Title>{t('rm:duration')}</S.Title>
              <S.Text>
                {data?.duration}
                {data?.remaining && ` - ${data?.remaining}`}
              </S.Text>
            </S.SectionWrapper>
          )}
        </S.Container>
      )}
    </>
  )
}

export default DurationDate
